/*
 * @category  Puma
 * @author    Deniss Dubinins <denissd@scandiweb.com | info@scandiweb.com>
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 * @copyright Copyright (c) 2021 Scandiweb, Inc (https://scandiweb.com)
 */

export class ConfigQueryPlugin {
    aroundGetStoreConfigFields = (args, callback, instance) => [
        ...callback.apply(instance, args),
        'national_id_number_enabled',
        'national_id_number_min_order_amount'
    ];
}

export const { aroundGetStoreConfigFields } = new ConfigQueryPlugin();

export const config = {
    'Query/Config/Query': {
        'member-function': {
            _getStoreConfigFields: aroundGetStoreConfigFields
        }
    }
};

export default config;
